import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ResponseInterceptor } from './responseInterceptor';
import { ApiPrefixInterceptor } from './apiPrefixInterceptor';
import { AuthInterceptor } from './authInterceptor';
import { AntiCacheInterceptor } from './antiCacheInterceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ApiPrefixInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AntiCacheInterceptor, multi: true },
];
